import { PersonSupplementaryInsuranceState } from '../../states/offer/offer.state';
import { assertPresent } from '../../utils/typeUtils';
import { SupplementaryInsuranceConfigurationTexts } from '../supplementary-insurance-configurations';

export function mapComplementaryTexts(
  supplementaryInsurances: PersonSupplementaryInsuranceState,
): SupplementaryInsuranceConfigurationTexts {
  const insurance = assertPresent(supplementaryInsurances.complementary, 'supplementaryInsurances.complementary');

  return {
    productKey: 'COMPLEMENTARY',
    productConfig: [
      {
        key: `SUMMARY.SUPPLEMENTARY_INSURANCE.PRODUCT.COMPLEMENTARY.CRITERIA.LEVEL.${insurance.level}`,
      },
    ],
  };
}
